<div class="board crm-scroll">
  <div
    class="board-columns"
    cdkDropList
    cdkDropListGroup
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="dropGrid($event)"
  >
    @for (column of board?.columns; track column) {
      <div class="board-column">
        <div>
          <div
            class="pointer"
            [ngStyle]="{ '--column-bg-color': column.bg_color, '--column-text-color': column.text_color }"
          >
            <div class="name px-2">{{ column.name }}</div>
            ({{ column.count_cards ?? 0 }})
          </div>
          @if (board.settings.price) {
            <div class="profit p-2 text-truncate">{{ parseCurrencyXXX(column.profit || 0, funnel.currency) }}</div>
          }
          <button
            [id]="column.id"
            mat-button
            class="w-100 d-flex justify-content-center align-items-center text-white bg-none"
            (mouseenter)="quickDealsId = column.id"
            (click)="toggleNameInput(column.id); createCard(column)"
          >
            <div class="d-flex gap-2 align-items-center">
              <app-icon>add</app-icon>
              @if (column.id === quickDealsId) {
                <span class="opacity-75">{{ 'quick_deal' | translate }}</span>
              }
            </div>
          </button>
        </div>
        <div
          cdkDropList
          [id]="column.id"
          class="tasks-container crm-scroll"
          (scroll)="baseService.currentUserInfo?.settings?.is_lazy_loading && scrollTo($event, column)"
          [cdkDropListData]="column.cards"
          (cdkDropListDropped)="drop($event)"
        >
          @if (column.is_create) {
            <ng-container *ngTemplateOutlet="createTemplateRef"></ng-container>
          }
          @for (item of column.cards; track item) {
            <div
              class="task"
              cdkDrag
              (mouseenter)="isOverCard = true"
              (mouseleave)="isOverCard = false"
              (cdkDragStarted)="startDrag($event)"
              (cdkDragEnded)="endedDrag()"
              (cdkDragMoved)="dragMoved($event)"
              (cdkDragDropped)="dragDropped($event, item)"
            >
              <div
                class="task__placeholder"
                *cdkDragPlaceholder
                [ngStyle]="{ '--height-placeholder': offsetHeight + 'px' }"
              ></div>
              <ng-container *ngTemplateOutlet="cardTemplateRef; context: { item: item }"></ng-container>
            </div>
          }
        </div>
      </div>
    }

    <div
      class="board-block"
      [style.display]="isDragging || isOverCard ? 'flex' : 'none'"
      [style.pointer-events]="isDragging || isOverCard ? 'auto' : 'none'"
      [style.opacity]="isDragging ? 1 : 0.2"
    >
      @for (item of bottomMenu; track item; let i = $index) {
        <div
          class="board-item"
          [ngClass]="{ 'board-line': i === 1 }"
          cdkDropList
          [ngStyle]="{ '--color': item.color }"
          [cdkDropListConnectedTo]="connectedList"
          (cdkDropListDropped)="drop($event)"
          [id]="item.id"
        >
          {{ item.name | translate }}
        </div>
      }
    </div>
  </div>
</div>
